export default __webpack_public_path__ + "static/bold-integration-000fb53ae211b2ab97f0b5017ce0018f.svg";